// src/components/AllegatoOffertaNF.js
// «Link/PDF Offerta» della NF (W435): si allega il file dell'offerta scegliendolo dal computer
// o dal telefono (PDF o immagine, massimo 10 MB), oppure si incolla un indirizzo.
// Il file va nello spazio file di Firebase (Storage), come i DDT e le pratiche.
import React, { useRef, useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";
import { useToast } from "../utils/Toast";
import { messaggioErrore } from "../utils/erroriUtente";

export const MAX_MB_OFFERTA = 10;
const TIPI = /\.(pdf|jpe?g|png|webp|heic)$/i;

export default function AllegatoOffertaNF({ orgId, allegato, onAllegato, link, onLink, disabilitato = false, inp = {} }) {
  const { addToast } = useToast();
  const [caricando, setCaricando] = useState(false);
  const input = useRef(null);
  const scegli = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!TIPI.test(file.name)) { addToast("Si possono allegare PDF o immagini (JPG, PNG)", "error"); return; }
    if (file.size > MAX_MB_OFFERTA * 1024 * 1024) { addToast(`Il file supera ${MAX_MB_OFFERTA} MB: riducilo o incolla il link`, "error"); return; }
    setCaricando(true);
    try {
      const nome = file.name.replace(/[^\w.-]+/g, "_").replace(/_+/g, "_");
      const path = `nf-offerte/${orgId}/${Date.now()}_${nome}`;
      const r = ref(storage, path);
      await uploadBytes(r, file);
      onAllegato({ url: await getDownloadURL(r), nome: file.name, path, tipo: /\.pdf$/i.test(file.name) ? "pdf" : "foto" });
      addToast("Offerta allegata ✅", "success");
    } catch (err) { addToast(messaggioErrore(err, "allegare il file"), "error"); }
    setCaricando(false);
  };
  return (
    <div>
      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
        <input style={{ ...inp, flex: 1 }} value={link || ""} disabled={disabilitato} onChange={e => onLink(e.target.value)} placeholder="Incolla un link…" aria-label="Link dell'offerta"/>
        {!disabilitato && (
          <button type="button" onClick={() => input.current?.click()} disabled={caricando}
            style={{ whiteSpace: "nowrap", fontSize: 12, fontWeight: 600, padding: "7px 10px", borderRadius: 8, border: "1px solid #c4b5fd", background: "#faf5ff", color: "#6d28d9", cursor: "pointer", fontFamily: "'Inter',sans-serif" }}>
            {caricando ? "Caricamento…" : "📎 Allega file"}
          </button>
        )}
        <input ref={input} type="file" accept=".pdf,image/*" onChange={scegli} style={{ display: "none" }} aria-label="Scegli il file dell'offerta"/>
      </div>
      {allegato?.url && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 5, fontSize: 12 }}>
          <a href={allegato.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2563eb", fontWeight: 600 }}>📎 {allegato.nome || "Offerta allegata"}</a>
          {!disabilitato && <button type="button" title="Togli l'allegato" onClick={() => onAllegato(null)} style={{ border: "none", background: "none", color: "#9ca3af", cursor: "pointer" }}>✕</button>}
        </div>
      )}
    </div>
  );
}
